import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetName from 'utils/getName';
import getSi from 'utils/getSi';
import updateHealthIssuesAnswers from 'utils/updateHealthIssuesAnswers';
import updateQuizInfo, { getQuizInfo } from 'utils/updateQuizInfo';
import DotDetails from '../DotDetails/DotDetails';
import DotSelector from '../DotSelector/DotSelector';
import QuizSlideNavigation from '../QuizSlideNavigation/QuizSlideNavigation';
import QuizSlideHeading from '../QuizSlideHeading/QuizSlideHeading';

const QuizDermatologyTwo = () => {
  const navigate = useNavigate();
  const si = getSi();

  const [name, setName] = useState('');
  const contextName = useSelector((state) => state.quiz.name);
  const dispatch = useDispatch();

  useEffect(() => {
    const dogName = async () => {
      if (contextName) {
        setName(contextName);
      } else {
        const n = await GetName(si, dispatch);
        setName(n);
      }
    };
    dogName();
  }, [si]);

  useEffect(() => {
    const info = getQuizInfo();
    if (info?.dermatology_q2) {
      setOption(info.dermatology_q2);
    }
  }, []);

  useEffect(() => {
    if (si) {
      updateQuizInfo({ slide: 'dermatology-2' });
    } 
  }, [si]);
  const [option, setOption] = useState(1);
  const dotSelectorData = [{ name: 1 }, { name: 2 }, { name: 3 }];
  const handleClick = () => {
    if (option) {
      updateQuizInfo({ dermatology_q2: option });
      updateHealthIssuesAnswers({ dermatology_q2: option });
      navigate(`/quiz/dermatology-3/?si=${si}`);
    }
  };

  const dotDetailsData = [
    {
      title: 'Not at all',
      body: 'My dog gets sore ears 1 to 2 times or less per year',
    },
    {
      title: 'Somewhat',
      body: 'My dog needs to see the vet fairly often for sore ears (>2x per year)',
    },
    {
      title: 'Significantly',
      body: 'My dog’s ears are constantly inflamed and/or dirty',
    },
  ];
  return (
    <section className="min-h-screen bg-dteal-50 pt-24 md:pt-4">
      <div className="container mx-auto flex h-screen flex-col items-center justify-center gap-12">
        <QuizSlideHeading
          before={`Does ${name}`}
          title="Get sore/inflamed/dirty ears?"
        />

        <div>
          <DotSelector
            data={dotSelectorData}
            option={option}
            setOption={setOption}
            details={dotDetailsData}
          />
          <DotDetails details={dotDetailsData} />
        </div>
        <QuizSlideNavigation  handleBack={()=>navigate(-1)}   handleNext={handleClick} />
      </div>
    </section>
  );
};

export default QuizDermatologyTwo;
